import { ReactNode } from 'react';
import { makeStyles } from 'tss-react/mui';
import { getColors } from '../tokens/getColors';
import { FAB } from './FAB';
import { ODPHeader } from './ODPHeader';
import {
  ODPSidebar,
  SIDEBAR_COLLAPSED_WIDTH,
  SIDEBAR_WIDTH,
} from './ODPSidebar';
import { SidebarProvider, useSidebar } from './SidebarContext';

interface ODPLayoutProps {
  children: ReactNode;
  transparentHeader?: boolean;
  headerActions?: ReactNode;
}

const useStyles = makeStyles()(theme => {
  const c = getColors(theme.palette.mode);
  return {
    layout: {
      display: 'flex',
      height: '100vh',
      overflow: 'hidden',
      backgroundColor: c.background.default,
    },
    mainContent: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      height: '100vh',
      position: 'relative' as const,
      overflow: 'hidden',
    },
    content: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      overflow: 'auto',
      minHeight: 0,
    },
  };
});

const ODPLayoutInner = ({
  children,
  transparentHeader = false,
  headerActions,
}: ODPLayoutProps) => {
  const { collapsed } = useSidebar();
  const { classes } = useStyles();

  return (
    <div className={classes.layout}>
      <ODPSidebar />
      <main
        className={classes.mainContent}
        style={{
          marginLeft: collapsed ? SIDEBAR_COLLAPSED_WIDTH : SIDEBAR_WIDTH,
        }}
      >
        <ODPHeader transparent={transparentHeader} actions={headerActions} />
        <div className={classes.content}>{children}</div>
      </main>
      <FAB />
    </div>
  );
};

export const ODPLayout = (props: ODPLayoutProps) => (
  <SidebarProvider>
    <ODPLayoutInner {...props} />
  </SidebarProvider>
);
